import { render, staticRenderFns } from "./EmptyQuestion.vue?vue&type=template&id=0a702b6f"
import script from "./EmptyQuestion.vue?vue&type=script&lang=js"
export * from "./EmptyQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports